<template>
  <div class="app-shell" :class="{ 'app-shell-standalone': isStandaloneLayout }">
    <template v-if="!isStandaloneLayout">
      <div class="page-backdrop" aria-hidden="true">
        <img src="/images/logo4.webp" alt="">
      </div>

      <SiteShell />
    </template>

    <main
      class="page-main"
      :class="[
        route.meta.mainClass,
        { 'page-main-standalone': isStandaloneLayout },
      ]"
    >
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import SiteShell from "@/components/SiteShell.vue";
import { useContentStore } from "@/store/contentStore";

const route = useRoute();
const { ensureContentLoaded } = useContentStore();
const routeBodyClasses = [
  "page-tech-notes",
  "page-tech-article",
  "page-light-videos",
  "page-light-video",
  "page-sound-blank",
  "page-common-software",
  "page-admin-editor",
  "page-xfpaint",
];

const isStandaloneLayout = computed(() => Boolean(route.meta.standaloneLayout));
const siteIcons = [
  { rel: "icon", type: "image/png", sizes: "32x32", href: "/images/favicon-32.png" },
  { rel: "icon", type: "image/png", sizes: "48x48", href: "/images/favicon-48.png" },
  { rel: "apple-touch-icon", href: "/images/apple-touch-icon.png" },
];

const syncBodyClass = (nextClass) => {
  routeBodyClasses.forEach((className) => {
    document.body.classList.toggle(className, className === nextClass);
  });
};

const syncSiteIcons = () => {
  siteIcons.forEach((icon) => {
    const selector = icon.sizes
      ? `link[rel="${icon.rel}"][sizes="${icon.sizes}"]`
      : `link[rel="${icon.rel}"]`;
    let link = document.head.querySelector(selector);

    if (!link) {
      link = document.createElement("link");
      link.rel = icon.rel;
      document.head.appendChild(link);
    }

    link.href = icon.href;
    if (icon.type) {
      link.type = icon.type;
    }
    if (icon.sizes) {
      link.sizes = icon.sizes;
    }
  });
};

watch(
  () => route.meta.bodyClass,
  (bodyClass) => {
    syncBodyClass(bodyClass);
    syncSiteIcons();

    if (route.meta.title) {
      document.title = route.meta.title;
    }
  },
  { immediate: true }
);

onMounted(() => {
  ensureContentLoaded();
});

onBeforeUnmount(() => {
  routeBodyClasses.forEach((className) => {
    document.body.classList.remove(className);
  });
});
</script>

<style scoped>
.app-shell-standalone {
  min-height: 100vh;
}

.page-main.page-main-standalone {
  width: 100%;
  max-width: none;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
